import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import locale from './../../utils/localization.json';
import ObjectCard from './ObjectCard';

const Object = ({ type }) => {
    const lang = useSelector((state) => state.language);
    const currentObject = useSelector((state) => state.currentObject);
    const viewer = useSelector((state) => state.viewer);
    const models = useSelector((state) => state.models);
    const pointclouds = useSelector((state) => state.pointclouds);
    const panoramas = useSelector((state) => state.panoramas);
    const {
        permissions: {
            point_cloud: { analyze },
        },
    } = useSelector((state) => state.currentProject);

    const [sortedObjects, setSortedObjects] = useState([]);

    useEffect(() => {
        let objects =
            type === 'model'
                ? [...models]
                : type === 'pointcloud'
                ? [
                      ...pointclouds.filter(
                          (p) =>
                              (analyze &&
                                  p.modelId ===
                                      currentObject._id +
                                          currentObject.version) ||
                              (!p.modelId &&
                                  (!pointclouds.find(
                                      ({ status, name, type, modelId }) =>
                                          status &&
                                          modelId ===
                                              currentObject._id +
                                                  currentObject.version &&
                                          name === p.name &&
                                          type === p.type
                                  ) ||
                                      !analyze))
                      ),
                  ]
                : [...panoramas];

        setSortedObjects(() =>
            objects
                .sort((a, b) =>
                    a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                )
                .filter((object) => object.urn !== currentObject.urn)
        );
    }, [currentObject, models, pointclouds, panoramas, type, analyze]);

    return (
        <div className="inline-flex flex-col gap-6 w-full">
            {sortedObjects.length === 0 ? (
                <div className="text-modelic-gray-100 self-center text-center">
                    {type === 'model'
                        ? locale[lang].noModel
                        : type === 'pointcloud'
                        ? locale[lang].noPointCloud
                        : locale[lang].noPanorama}
                </div>
            ) : viewer?.model?.getDocumentNode()?.data?.role === '2d' &&
              type !== 'model' ? (
                <div className="text-modelic-gray-100 self-center text-center">
                    {type === 'pointcloud'
                        ? locale[lang].unableAddPointcloud
                        : locale[lang].unableAddPanorama}
                </div>
            ) : (
                sortedObjects.map((object) => (
                    <ObjectCard
                        key={object.urn || object.filename || object.name}
                        object={object}
                        objectType={type}
                    />
                ))
            )}
        </div>
    );
};

export default Object;
